import React, { useState } from 'react';
import { Filter, ExternalLink, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { projects } from '../mock';
import { Button } from './ui/button';

export const Projects = () => {
  const [hoveredId, setHoveredId] = useState(null);
  
  // Nur die ersten 4 Projekte auf der Startseite anzeigen
  const previewProjects = projects.slice(0, 4);

  return (
    <section id="projects" className="py-24 relative overflow-hidden">
      {/* Background with geometric patterns */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-50 via-white to-gray-50"></div>
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-bl from-[#E6F7FF] to-transparent opacity-40 transform skew-x-12"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-black to-[#00CCDD] text-white px-6 py-2 rounded-full mb-6">
            <Filter className="w-4 h-4" />
            <span className="font-semibold text-sm uppercase tracking-wide">Unsere Referenzen</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-black mb-6">
            Erfolgreich umgesetzte <span className="text-transparent bg-clip-text bg-gradient-to-r from-black to-[#00CCDD]">Projekte</span>
          </h2>
          <p className="text-xl text-gray-600">
            Ein Auszug aus unseren erfolgreich abgeschlossenen Bauprojekten
          </p>
        </div>

        {/* Projects Grid - Preview (4 Projekte) */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {previewProjects.map((project) => (
            <div
              key={project.id}
              className="group relative"
              onMouseEnter={() => setHoveredId(project.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500">
                {/* Image Container with Diagonal Overlay */}
                <div className="relative h-80 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className={`w-full h-full object-cover transition-transform duration-700 ${
                      hoveredId === project.id ? 'scale-110' : 'scale-100'
                    }`}
                  />
                  
                  {/* Diagonal gradient overlay */}
                  <div className={`absolute inset-0 bg-gradient-to-br from-black/90 via-black/80 to-[#00CCDD]/70 transition-opacity duration-500 ${
                    hoveredId === project.id ? 'opacity-90' : 'opacity-0'
                  }`}>
                    {/* Diagonal lines pattern */}
                    <div className="absolute inset-0 opacity-20">
                      <div className="absolute top-0 left-0 w-full h-full transform skew-x-12 bg-gradient-to-r from-transparent via-white to-transparent"></div>
                    </div>
                  </div>

                  {/* Year Badge */}
                  <div className="absolute top-4 right-4 bg-gradient-to-r from-black to-[#00CCDD] text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                    {project.year}
                  </div>

                  {/* Hover Content */}
                  {hoveredId === project.id && (
                    <div className="absolute inset-0 flex items-center justify-center p-6">
                      <div className="text-center text-white space-y-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
                        <h3 className="text-2xl font-bold">{project.title}</h3>
                        <p className="text-white/90">{project.description}</p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Card Content */}
                <div className="p-6">
                  <div className="mb-3">
                    <span className="inline-block bg-gradient-to-r from-[#E6F7FF] to-[#CCF2FF] text-black text-xs font-bold px-4 py-1.5 rounded-full border border-[#00CCDD]/30">
                      {project.category}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-black mb-2 group-hover:text-[#00CCDD] transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{project.description}</p>
                </div>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-black via-[#00CCDD] to-black transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA to full projects page */}
        <div className="text-center">
          <Link to="/projekte">
            <Button
              size="lg"
              className="bg-gradient-to-r from-black to-[#00CCDD] hover:from-black hover:to-black text-white px-8 group"
            >
              Alle Projekte ansehen
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <p className="text-gray-600 mt-4">
            Entdecken Sie alle {projects.length} erfolgreich abgeschlossenen Projekte
          </p>
        </div>
      </div>
    </section>
  );
};